<div class="w-full max-w-md pt-10 mx-auto">
  <a routerLink="/"
    class="inline-flex items-center text-sm text-gray-500 transition-colors hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300">
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none" class="size-5">
      <path d="M12.7083 5L7.5 10.2083L12.7083 15.4167" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round"></path>
    </svg>
    Volver al inicio
  </a>
</div>

<div class="flex flex-col justify-center flex-1 w-full max-w-md mx-auto py-10">

  <!-- ==================== Confirmación ==================== -->
  @if (submitted) {
    <div class="text-center">
      <div class="flex items-center justify-center w-16 h-16 mx-auto mb-6 rounded-full bg-success-50 dark:bg-success-500/15">
        <svg class="w-8 h-8 text-success-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h1 class="mb-3 font-semibold text-gray-800 text-title-sm dark:text-white/90">
        Recibimos tu solicitud
      </h1>
      <p class="mb-8 text-sm text-gray-500 dark:text-gray-400">
        Gracias, {{ fullname }}. Nuestro equipo revisará la solicitud de
        <span class="font-medium text-gray-700 dark:text-gray-300">{{ companyName }}</span>
        y te escribirá a <span class="font-medium text-gray-700 dark:text-gray-300">{{ email }}</span>
        para coordinar una demostración y darte de alta.
      </p>
      <a routerLink="/"
        class="inline-flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white transition rounded-lg bg-brand-500 hover:bg-brand-600">
        Volver al inicio
      </a>
    </div>
  } @else {

    <div class="mb-5 sm:mb-8">
      <h1 class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
        Acceder a Partner CRM
      </h1>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        Partner CRM es una plataforma para empresas y las cuentas las damos de alta
        nosotros. Si ya te invitaron, canjea tu código; si no, cuéntanos de tu equipo.
      </p>
    </div>

    <!-- ==================== Selector de camino ==================== -->
    <div class="grid grid-cols-2 gap-2 p-1 mb-6 bg-gray-100 rounded-lg dark:bg-gray-800">
      <button type="button" (click)="setMode('request')"
        [class]="mode === 'request'
          ? 'px-3 py-2 text-sm font-medium text-gray-800 bg-white rounded-md shadow-sm dark:bg-gray-700 dark:text-white/90'
          : 'px-3 py-2 text-sm font-medium text-gray-500 rounded-md hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'">
        Solicitar acceso
      </button>
      <button type="button" (click)="setMode('invitation')"
        [class]="mode === 'invitation'
          ? 'px-3 py-2 text-sm font-medium text-gray-800 bg-white rounded-md shadow-sm dark:bg-gray-700 dark:text-white/90'
          : 'px-3 py-2 text-sm font-medium text-gray-500 rounded-md hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'">
        Tengo una invitación
      </button>
    </div>

    <!-- ==================== Camino 1: solicitar acceso ==================== -->
    @if (mode === 'request') {
      @if (errorMessage) {
        <div class="mb-5">
          <app-alert [variant]="'error'" [message]="errorMessage"></app-alert>
        </div>
      }

      <form (ngSubmit)="submitRequest()">
        <div class="space-y-5">
          <div>
            <app-label for="fullname">
              Nombre y apellidos<span class="text-error-500">*</span>
            </app-label>
            <app-input-field type="text" id="fullname" name="fullname" placeholder="Ej. María Fernández"
              [(value)]="fullname" autocomplete="name" />
          </div>

          <div>
            <app-label for="companyName">
              Empresa<span class="text-error-500">*</span>
            </app-label>
            <app-input-field type="text" id="companyName" name="companyName" placeholder="Ej. Comercial Andina S.A.C."
              [(value)]="companyName" autocomplete="organization" />
          </div>

          <div>
            <app-label for="email">
              Correo corporativo<span class="text-error-500">*</span>
            </app-label>
            <app-input-field type="email" id="email" name="email" placeholder="tu@empresa.com"
              [(value)]="email" autocomplete="email" />
          </div>

          <div>
            <app-label for="phone">Teléfono</app-label>
            <app-input-field type="tel" id="phone" name="phone" placeholder="+51 999 888 777"
              [(value)]="phone" autocomplete="tel" />
          </div>

          <div>
            <app-label for="message">¿Qué necesitas resolver?</app-label>
            <textarea id="message" name="message" rows="3" [(ngModel)]="message"
              [ngModelOptions]="{ standalone: true }"
              placeholder="Cuántas personas usarían el CRM, qué procesos quieres ordenar…"
              class="w-full px-4 py-2.5 text-sm text-gray-800 bg-transparent border border-gray-300 rounded-lg shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"></textarea>
          </div>

          <!--
            Honeypot anti-bots: fuera del flujo visual y del foco por teclado. Una
            persona nunca lo ve; un bot que rellena todos los inputs sí, y entonces
            el backend descarta la solicitud en silencio.
          -->
          <div class="absolute w-px h-px overflow-hidden opacity-0 -left-[9999px]" aria-hidden="true">
            <label for="website">No completar</label>
            <input type="text" id="website" name="website" tabindex="-1" autocomplete="off"
              [(ngModel)]="website" [ngModelOptions]="{ standalone: true }" />
          </div>

          <button type="submit" [disabled]="!canSubmitRequest"
            class="flex items-center justify-center w-full gap-2 px-4 py-3 text-sm font-medium text-white transition rounded-lg bg-brand-500 shadow-theme-xs hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
            @if (isSubmitting) {
              <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                </path>
              </svg>
              Enviando…
            } @else {
              Solicitar acceso
            }
          </button>

          <p class="text-xs text-center text-gray-500 dark:text-gray-400">
            Al enviar aceptas nuestros
            <a href="/terms" target="_blank" class="text-brand-500 hover:underline">Términos de Servicio</a>
            y nuestra
            <a href="/privacy" target="_blank" class="text-brand-500 hover:underline">Política de Privacidad</a>.
          </p>
        </div>
      </form>
    }

    <!-- ==================== Camino 2: canjear invitación ==================== -->
    @if (mode === 'invitation') {
      @if (codeError) {
        <div class="mb-5">
          <app-alert [variant]="'error'" [message]="codeError"></app-alert>
        </div>
      }

      <form (ngSubmit)="redeemCode()">
        <div class="space-y-5">
          <div>
            <app-label for="invitationCode">
              Código de invitación<span class="text-error-500">*</span>
            </app-label>
            <app-input-field type="text" id="invitationCode" name="invitationCode"
              placeholder="Pega aquí el código o el enlace del correo"
              [(value)]="invitationCode" autocomplete="off" />
            <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
              Lo recibiste en el correo de invitación. Puedes pegar el enlace completo.
            </p>
          </div>

          <button type="submit" [disabled]="isCheckingCode || !invitationCode.trim()"
            class="flex items-center justify-center w-full gap-2 px-4 py-3 text-sm font-medium text-white transition rounded-lg bg-brand-500 shadow-theme-xs hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
            @if (isCheckingCode) {
              <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                </path>
              </svg>
              Validando…
            } @else {
              Continuar
            }
          </button>
        </div>
      </form>
    }

    <div class="mt-6">
      <p class="text-sm font-normal text-center text-gray-700 dark:text-gray-400">
        ¿Ya tienes cuenta?
        <a routerLink="/signin" class="text-brand-500 hover:text-brand-600 dark:text-brand-400">Iniciar sesión</a>
      </p>
    </div>
  }
</div>
